export const proposaltype = [
    {
        label: 'Core',
        value: 'C',
    },
    {
        label: 'ToO',
        value: 'T',
    },
    {
        label: 'Guest',
        value: 'G',
    },
    {
        label: 'Temp',
        value: 'M',
    },
];

export const proposaltype_IE = [
    //提案类别：一个字符G/T/C/M、对应界面显示内容Guest/Too/Core/Temp  用于insert和edit窗口
    {
        label: 'Core',
        value: 'C',
    },
    {
        label: 'ToO',
        value: 'T',
    },
    {
        label: 'Guest',
        value: 'G',
    },
    {
        label: 'Temp',
        value: 'M',
    },
];

export const ObsModes =[
    {
        label: 'Pointing(P)',
        value: 'P', 
    },
    {
        label: 'All Sky Survey(S)',
        value: 'S', 
    },
    {
        label: 'Small Area Survey(A)',
        value: 'A', 
    },

];
export const CoreType = [
    //核心组成员类别
    {
        label: '首席科学家',
        value: '首席科学家',
    },
    {
        label: '组长',
        value: '组长',
    },
    {
        label: '副组长',
        value: '副组长',
    },
    {
        label: '组员',
        value: '组员',
    },
];

export const AuthStates = [
    //游客申请状态   用于查询窗口
    {
        label: '待审批',
        value: 'apply',
    },
    {
        label: '同意',
        value: 'ok',
    },
    {
        label: '拒绝',
        value: 'no',
    },
    {
        label: '全部',
        value: 'all',
    },
];
//用户数据申请状态
export const ApplyTypeEn=[
    {
        label: 'ALL',
        value: 'all',
    },
    {
        label: 'Applying',
        value: 'apply',
    },
    {
        label: 'Authorized',
        value: 'ok',
    },
    {
        label: 'Refuse',
        value: 'no',
    },
];

//用户数据申请状态
export const ApplyTypeZh=[
    {
        label: '全部',
        value: 'all',
    },
    {
        label: '申请中',
        value: 'apply',
    },
    {
        label: '已授权',
        value: 'ok',
    },
    {
        label: '被拒绝',
        value: 'no',
    },
];

export const Iopen = [
    //是否公开：000或者001 用于search窗口
    {
        label: 'Open',
        value: '1',
    },
    {
        label: 'Not Open',
        value: '0',
    },
];

export const Iopen_IE = [
    //是否公开：000或者001 用于insert和edit窗口
    {
        label: 'Open',
        value: '1',
    },
    {
        label: 'Not Open',
        value: '0',
    },
];

export const datastatus = [
    //数据状态 一个字符U/O/A/P，显示对应Unavailable/Obsolete/Archived/Processing  用于查询窗口
    {
        label: 'Unavailable',
        value: 'U',
    },
    {
        label: 'Obsolete',
        value: 'O',
    },
    {
        label: 'Archived',
        value: 'A',
    },
    {
        label: 'Processing',
        value: 'P',
    },
];

export const datastatus_IE = [
    //数据状态 一个字符U/O/A/P，显示对应Unavailable/Obsolete/Archived/Processing  用于insert和edit窗口

    {
        label: 'Unavailable',
        value: 'U',
    },
    {
        label: 'Obsolete',
        value: 'O',
    },
    {
        label: 'Archived',
        value: 'A',
    },
    {
        label: 'Processing',
        value: 'P',
    },
];

export const filedatatable = [
    //数据表：不同表类别 ‘0’ obs-data  ‘1’ grb-data ‘2’ sem-data '   用于insert和edit窗口
    {
        label: 'Proposal',
        value: 'OBS',
    },
    {
        label: 'GRB',
        value: 'GRB',
    },
    {
        label: 'SEM',
        value: 'SEM',
    },
];
export const downfiletype = [
    //数据表：   用于insert和edit窗口
    {
        label: 'Proposal',
        value: 'OBS',
    },
    {
        label: 'GRB',
        value: 'GRB',
    },
    {
        label: 'SEM',
        value: 'SEM',
    },
    {
        label: '升级包',
        value: 'upk',
    },
];

export const DataLevel = [
    //数据级别1L/2L/1G/1P   用于insert和edit窗口
    {
        label: '1L',
        value: '1L',
    },
    {
        label: '2L',
        value: '2L',
    },
    {
        label: '1G',
        value: '1G',
    },
    {
        label: '1P',
        value: '1P',
    },
];
export const PropDataLevel = [
    //数据级别,选择proposal时为此
    {
        label: '1L',
        value: '1L',
    },
    {
        label: '1.5L',
        value: '15L',
    },
    {
        label: '2L',
        value: '2L',
    },
];
export const SemDataLevel = [
    //数据级别,选择SEM时为此
    {
        label: '1L',
        value: '1L',
    },
    {
        label: '2L',
        value: '2L',
    },
];
export const DataMode = [
    //数据模式 1个字符 N/L 显示 Normal/LowGain  用于insert和edit窗口
    {
        label: 'Normal',
        value: 'N',
    },
    {
        label: 'LowGain',
        value: 'L',
    },   
];

export const ObsMode = [
    //观测模式 1个字符P/S/A显示Pointing/ ASS/ SAS  用于insert和edit窗口
    {
        label: 'Pointing',
        value: 'P',
    },
    {
        label: 'ASS',
        value: 'S',
    }, 
    {
        label: 'SAS',
        value: 'A',
    },
];

export const IsAdmin = [
    //是否管理员 0否 1数据管理员 2系统管理员
    {
        label: '用户',
        value: '0',
    },
    {
        label: '数据管理员',
        value: '1',
    }, 
    {
        label: '系统管理员',
        value: '2',
    },
];

export const UserPositionen = [
    //用户职位 0学生 核心组成员 非核心组成员
    {
        label: 'Student',
        value: 'student',
    },
    {
        label: 'Core group members',
        value: 'core',
    }, 
    {
        label: 'Non core group members',
        value: 'noncore',
    },
];

export const UserPositionzh = [
    //用户职位 0学生 核心组成员 非核心组成员
    {
        label: '学生',
        value: 'student',
    },
    {
        label: '核心组成员',
        value: 'core',
    }, 
    {
        label: '非核心组成员',
        value: 'noncore',
    },
];

export const Includedata = [
    //用户职位 0学生 核心组成员 非核心组成员
    {
        label: '观测数据',
        value: '1',
    },
    {
        label: '提案数据',
        value: '2',
    }, 
    {
        label: '同源数据',
        value: '3',
    },
    {
        label: '全部',
        value: 'all',
    },
];

